import Layout from "../../components/Layout";
import React from "react";
import EducatorCategoryList from "../../components/EducatorCategoryList";
import { Helmet } from "react-helmet";

export default () => {
  const title = "Family Enrichment Category | Educator Resources";
  const description =
    "Working with children is a constant learning process! Here, you’ll find resources, research summaries, and suggestions for happy, harmonious, and enriching growth.";
  return (
    <Layout>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      <section className="section">
        <div className="container">
          <div className="content">
            <h1 className="title">Family Enrichment</h1>
            <p>{description}</p>
            <EducatorCategoryList category="family-enrichment" />
          </div>
        </div>
      </section>
    </Layout>
  );
};
